import React, { useEffect, useState, useCallback, Fragment } from 'react';
import styled, { createGlobalStyle } from 'styled-components';
import { icon_bridge_people } from 'components/base/images';
import { useShallowAppSelector } from 'store/hooks';
import { IProjectInfo } from 'lib/types/projectTypes';
import { appList } from 'lib/mapper';
import { AppActions, BaseActions, FileActions, ProjectActions } from 'store/actionCreators';
import AlertModalContent from 'components/common/modal/contents/AlertModalContent';
import cx from 'classnames';
import Tooltip from '@material-ui/core/Tooltip';
import Fade from '@material-ui/core/Fade';
import { useDidUpdateEffect } from 'lib/utils';
import { useHistory } from 'react-router-dom';

const ExcuteApps = () => {
  const {
    projectData,
    hasAlarm,
    projectFilesData: { fileData },
    projectFilesSuccess,
    isReScan,
  } = useShallowAppSelector(state => ({
    projectFilesData: state.file.projectFiles.data || {},
    projectFilesSuccess: state.file.projectFiles.success,
    projectData: state.project.project.data,
    hasAlarm: state.project.hasAlarm,
    isReScan: state.base.isReScan,
  }));
  const projectInfo: IProjectInfo = projectData?.projectInfo;
  const [installedList, setInstalledList] = useState<string[]>([]);
  const { ipcRenderer } = window;

  const [clickBlock, setClickBlock] = useState<boolean>(false);
  const [isScanClick, setIsScanClick] = useState<boolean>(false);

  const history = useHistory();

  const notUsedServiceInBrowser = () => {
    AppActions.add_popup({
      isOpen: true,
      isCloseIcon: true,
      title: '',
      content: (
        <AlertModalContent
          title="Alert"
          mainText="This Service not used in browser."
          subText="Sync Program only."
        />
      ),
      onClick() {
        return;
      },
      onCancel() {
        return;
      },
    });
  };

  const handleClickApp = useCallback(
    (appName: string) => {
      if (!ipcRenderer) {
        notUsedServiceInBrowser();
      } else {
        if (appName === 'APP_SCAN_IOS') {
          // NOTE: ScanFile 체크
          setIsScanClick(true);
          FileActions.fetch_project_files_request(projectInfo?.projectCode);
        } else {
          handleSendExcuteApp({
            appName,
            projectCode: projectInfo?.projectCode,
            projectId: projectInfo?.projectId,
          });
        }
        setClickBlock(true);
      }
    },
    [projectInfo],
  );

  const handleSendExcuteApp = ({
    appName,
    projectCode,
    projectId,
  }: {
    appName: string;
    projectCode: string;
    projectId: string;
  }) => {
    console.log('PMS] executeApp 실행');
    ipcRenderer.send('executeApp', {
      appName,
      projectCode,
      projectId,
    });
  };

  useDidUpdateEffect(() => {
    if (!isScanClick) return;
    if (!projectFilesSuccess) return;
    console.log('PMS] fileData __________ ', fileData.scanFileList);
    if (fileData.scanFileList.length > 0) {
      // NOTE: Project 복제
      BaseActions.is_re_scan(true);
      history.push(`/project/creating/${projectInfo?.projectCode}?pathTo=copy`);
      // ProjectActions.fetch_project_clear();
      // history.push(`/project/creating/${projectInfo?.projectCode}?pathTo=copy`);
    } else {
      handleSendExcuteApp({
        appName: 'APP_SCAN_IOS',
        projectCode: projectInfo?.projectCode,
        projectId: projectInfo?.projectId,
      });
    }
    setIsScanClick(false);
  }, [projectFilesSuccess, fileData, projectInfo, isScanClick]);

  useEffect(() => {
    console.log('PMS] isReScan ____________ ', isReScan);
    if (isReScan) {
      handleSendExcuteApp({
        appName: 'APP_SCAN_IOS',
        projectCode: projectInfo?.projectCode,
        projectId: projectInfo?.projectId,
      });
      BaseActions.is_re_scan(false);
    }
  }, [isReScan]);

  useEffect(() => {
    if (ipcRenderer) {
      if (!!projectInfo?.projectCode) {
        ipcRenderer.on('executeAppRes', (e: any, data: any) => {
          console.log('HDS] executeAppRes _________ ', JSON.stringify(data));
          setTimeout(() => {
            // NOTE: 연속 클릭 방지
            setClickBlock(false);
          }, 1000);
          // NOTE: 앱 실행 시, Project Store에 저장 -> project stage 변경 시 사용
          if (data.status === 'start') {
            const progressFlag = appList.find(
              (item: any) => item.code === data.appName,
            )?.progressFlag;
            const submitData = {
              appName: data.appName,
              progressFlag: progressFlag,
              projectCode: projectInfo.projectCode,
            };
            ProjectActions.set_excuteapp_timeline(submitData);
          }
          // alert('[Appname : ' + data.appName + ',  status : ' + data.status + ' ]');
        });
      }
    }
  }, [projectInfo]);

  useEffect(() => {
    if (ipcRenderer) {
      ipcRenderer.send('installedAppList', {});
    }
  }, []);

  useEffect(() => {
    if (ipcRenderer) {
      ipcRenderer.on('installedAppListRes', (e: any, data: any) => {
        setInstalledList(data.appList);
      });
    }
  }, []);

  const handleOpenBridge = () => {
    if (!ipcRenderer) return;
    ipcRenderer.send('openBrowser', {
      url: 'https://www.dofbridge.com/home',
    });
  };

  return (
    <Styled.ExcuteNav data-component-name="ExcuteApps">
      <h2 className="sr-only">Excute App</h2>

      <div className="excuteApps__container">
        <ul className="excuteApps__item_list">
          <StyledGlobalTooltip />
          {appList?.map((item, idx) => {
            const isInstalled = !!installedList?.find((appName: any) => appName === item.code);
            if (!isInstalled) return;
            if (item.code === 'APP_BASEAPP') return;
            if (item.code === 'APP_MOTIONAPP') return;
            return (
              <Fragment key={idx}>
                <Tooltip
                  className="excuteApps__tooltip"
                  title={item.name}
                  placement="top"
                  arrow
                  TransitionComponent={Fade}
                  TransitionProps={{ timeout: 300 }}
                >
                  <li className="excuteApps__item_box">
                    <div
                      className={cx('excuteApps__item', {})}
                      onClick={() => {
                        if (hasAlarm) return;
                        if (!clickBlock) handleClickApp(item.code);
                      }}
                    >
                      {!!item.icon ? (
                        <img src={item.icon} className="excuteApps__item_icon" alt="app icon" />
                      ) : (
                        <div className="excuteApps__item_icon empty"></div>
                      )}
                    </div>
                  </li>
                </Tooltip>
                <div className="item_line"></div>
                {/* {idx > 0 && <div className="item_line"></div>} */}
              </Fragment>
            );
          })}
          <Tooltip
            className="excuteApps__tooltip"
            title={'Dof Bridge'}
            placement="top"
            arrow
            TransitionComponent={Fade}
            TransitionProps={{ timeout: 300 }}
          >
            <li className="excuteApps__item_box">
              <div
                className="excuteApps__item"
                onClick={() => {
                  if (hasAlarm) return;
                  handleOpenBridge();
                }}
              >
                <img src={icon_bridge_people} className="excuteApps__item_icon" alt="app icon" />
              </div>
            </li>
          </Tooltip>
        </ul>
      </div>
    </Styled.ExcuteNav>
  );
};

const Styled = {
  ExcuteNav: styled.div`
    padding: 16px 20px;
    .excuteApps__container {
      .excuteApps__item_list {
        display: flex;
        align-items: center;
        .excuteApps__item_box {
          width: 70px;
          height: 53px;
          padding: 5px 15px;
          margin: 0 10px;
          position: relative;
          display: flex;
          align-items: center;
          justify-content: center;

          .excuteApps__item {
            scale: 1;
            transition-duration: 150ms;
            transition-property: scale;

            &:hover {
              cursor: pointer;
              scale: 1.4;
            }
            .excuteApps__item_icon {
              width: 100%;
              height: 100%;
              &.empty {
                border: 1px solid #e1e1e7;
                border-radius: 2px;
              }
            }
          }
          .excuteApps__item_dim {
            position: absolute;
            top: 0;
            left: 0;
            width: 30px;
            height: 30px;
            background-color: #000;
            opacity: 0.2;
            border-radius: 2px;
          }
        }
        .item_line {
          width: 1px;
          height: 30px;
          background-color: #e1e1e7;
        }
      }
    }
  `,
};

const StyledGlobalTooltip = createGlobalStyle<{}>`
  .MuiTooltip-popper {
    .MuiTooltip-tooltipPlacementTop {
      font-size: 14px;
      font-weight: 400;
      padding: 10px 15px;
      border-radius: 10px;
      background-color: #25256F;
      .MuiTooltip-arrow {
        color: #25256F;
      }
    }
}
`;

export default React.memo(ExcuteApps);
